// SkipLink — keyboard-accessible "skip to main content" link.
// Visually hidden until focused; first interactive element in the DOM.

export function SkipLink() {
  return (
    <a
      href="#main-content"
      style={{
        position: "absolute",
        left: 8,
        top: 8,
        padding: "8px 12px",
        background: "var(--md-primary)",
        color: "var(--md-on-primary)",
        borderRadius: "var(--r-md)",
        textDecoration: "none",
        font: "var(--t-title-sm)",
        zIndex: 1000,
        transform: "translateY(-200%)",
        transition: "transform 120ms ease",
      }}
      onFocus={(e) => { e.currentTarget.style.transform = "translateY(0)"; }}
      onBlur={(e) => { e.currentTarget.style.transform = "translateY(-200%)"; }}
    >
      Skip to main content
    </a>
  );
}

export default SkipLink;
